//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  BASIC
} from "@/config/constant"
import promise from '@/axios/promise'
import {
  formatTime,
  guid,
  isNullOrEmptyStr,
  isNullOrEmptyArr
} from "@/utils/common"
export default {
  name: 'taskDetail',
  data() {
    return {
      taskId: this.$route.query.taskId,
      taskType: this.$route.query.taskType,
      taskTopic: this.$route.query.taskTopic,
      showConfirm: this.$route.query.showConfirm,
      businessKey: this.$route.query.businessKey,
      taskVisible: false,
      taskHis: [],
      selects: [],
      columns: [
        // {
        //   title: '账号',
        //   name: 'userName',
        //   width: 80,
        //   align: 'center'
        // },
        {
          title: '审核人',
          name: 'realName',
          align: 'center'
        }
      ],
      variables: {},
      msg: "",
      Index: 0,
      status: "S",
      nextTaskDatas: [],
    }
  },
  created() {

  },
  methods: {
    openAlertDialog() {
      this.taskVisible = true;
    },
    closeAlertDialog() {
      this.taskVisible = false;
    },
    goBack() {
      this.$router.go(-1)
    },
    agreeTask: function () {
      this.status = "S";
      this.variables.status = this.status;
      if (this.showConfirm == 0) {
        this.taskVisible = true;
        this.getNextTaskDatas();
      } else {
        this.completeTask();
      }
    },
    refuseTask: function () {
      this.status = "E";
      this.variables.status = this.status;
      if (this.showConfirm == 0) {
        this.taskVisible = true;
        this.getNextTaskDatas();
      } else {
        this.completeTask();
      }
    },
    completeTask: function () {
      var map = {};
      map.variables = this.variables;
      promise({
        url: BASIC + "/task/completeTaskByTaskId?taskId=" + this.taskId + "&msg=" + this.msg + "&status=" +
          this.status,
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        data: JSON.stringify(map),
      }).then(res => {
        if (res.code == 0) {
          // Message({message:"操作成功！",type:"success"});
          this.taskVisible = false;
        } else {
          // Message({message:res.msg,type:"error"});
        }
      });
    },
    IndexClick: function (index) {
      this.Index = index;
    },
    taskConfirm: function () {
      //获取页面传递过来的变量
      var map = {};
      //审核意见
      //循环获取每个任务的办理人和任务主题
      var topics = {};
      var variables = this.variables;
      var flag = 0; //0正常 1任务配置 2任务主题 3办理人
      var msg = "";
      $.each(this.nextTaskDatas, function (index, row) {
        var task = row.task;
        var taskKey = task.taskDefinitionKey;
        var taskName = task.taskName;
        var actDicTask = row.actDicTask;
        if (taskKey != 'end') {
          if (actDicTask == null) {
            flag = 1;
            msg = "请配置该流程的" + taskName + "节点任务信息";
            return;
          } else if (actDicTask.taskType == null || actDicTask.taskType == '') {
            flag = 1;
            msg = "请配置该流程的" + taskName + "节点任务任务类型";
            return;
          } else if (actDicTask.userExpKey == null || actDicTask.userExpKey == '') {
            flag = 1;
            msg = "请配置该流程的" + taskName + "节点任务办理人方式";
            return;
          } else {
            //设置任务主题
            var taskTopic = task.taskTopic;
            if (taskTopic == null || taskTopic == '') {
              flag = 2;
              msg = taskName + "节点任务主题不能为空";
              return;
            }
            topics[taskKey] = taskTopic;
            //任务办理人
            var taskType = actDicTask.taskType;
            var userExpKey = actDicTask.userExpKey;
            var data = [];
            var checkedUsers = row.checkedUsers;
            if (checkedUsers != null && checkedUsers.length > 0) {
              $.each(row.users, function (index, user) {
                $.each(checkedUsers, function (index1, userIndex) {
                  if (userIndex == index) {
                    data.push(user);
                  }
                });
              });
            }
            if (taskType == 'Multi') {
              if (data == null || data.length == 0) {
                flag = 3;
                msg = taskName + "节点任务办理人不能为空";
                return;
              } else {
                var userVal = "";
                for (var i = 0; i < data.length; i++) {
                  var user = data[i];
                  if (i == 0) {
                    userVal += user.userName;
                  } else {
                    userVal = userVal + "," + user.userName
                  }
                }
                variables[userExpKey] = userVal;
              }
            } else {
              if (data == null || data.length == 0) {
                flag = 3;
                msg = taskName + "节点任务办理人不能为空";
                return;
              } else if (data.length > 1) {
                flag = 3;
                msg = taskName + "节点为单人任务";
                return;
              } else {
                variables[userExpKey] = data[0].userName;
              }
            }
          }
        } else {
          var taskTopic = task.taskTopic;
          if (taskTopic == null || taskTopic == "") {
            taskTopic = "结束"
          }
          topics.end = taskTopic;
        }
      });
      if (flag != 0) {
        // Message({message:msg,type:"error"});
        return;
      }
      //任务主题
      //设置流程办理人
      map.taskTopics = topics;
      map.variables = variables;
      this.taskVisible = false;
      promise({
        url: BASIC + "/task/completeTaskByTaskId?taskId=" + this.taskId + "&msg=" + this.msg + "&status=" +
          this.status,
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        data: JSON.stringify(map),
      }).then(res => {
        if (res.code == 0) {
          // Message({message:"操作成功！",type:"success"});
          this.taskVisible = false;
        } else {
          // Message({message:res.msg,type:"error"});
        }
      });
    },
    getTaskTopic: function (task, taskTopicExp) {
      if (task != null) {
        var commitUser = task.commitUser;
        if (commitUser == null || commitUser == '') {
          status = 'F';
        }
      }
      var taskTopic = '';
      if (taskTopicExp == null || taskTopicExp == '') {
        taskTopic = task.processDefinitionName + ":" + task.taskName + ":" + task.commitUserName;
      } else {
        var expArr = taskTopicExp.split(":");
        for (var i = 0; i < expArr.length; i++) {
          var exp = expArr[i];
          if (i == expArr.length - 1) {
            if (exp == null || exp == '') {
              continue;
            } else if (exp == "procName") {
              taskTopic = taskTopic + task.processDefinitionName;
            } else if (exp == "taskName") {
              taskTopic = taskTopic + task.taskName;
            } else if (exp == "commitUser") {
              taskTopic = taskTopic + task.commitUserName;
            } else {
              var expVal = $("#" + exp).val();
              if (expVal != undefined && expVal != null && expVal != "") {
                taskTopic = taskTopic + expVal;
              }
            }
          } else {
            if (exp == null || exp == '') {
              continue;
            } else if (exp == "procName") {
              taskTopic = taskTopic + task.processDefinitionName + ":";
            } else if (exp == "taskName") {
              taskTopic = taskTopic + task.taskName + ":";
            } else if (exp == "commitUser") {
              taskTopic = taskTopic + task.commitUserName + ":";
            } else {
              var expVal = $("#" + exp).val();
              if (expVal != undefined && expVal != null && expVal != "") {
                taskTopic = taskTopic + expVal + ":";
              }
            }
          }
        }
      }
      return taskTopic;
    },
    getNextTaskDatas: function () {
      var str = JSON.stringify(this.variables);
      console.info(str);
      promise({
        url: BASIC + "/task/getConfirmInfo?taskId=" + this.taskId + "&status=" + this.status,
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        data: str
      }).then(res => {
        var code = res.code;
        if (code == 0) {
          this.nextTaskDatas = res.data;
          var self = this;
          $.each(this.nextTaskDatas, function (index, row) {
            var taskTopic = self.getTaskTopic(row.task, row.actDicTask.taskTopic)
            row.task.taskTopic = taskTopic;
          });
          console.info(JSON.stringify(this.nextTaskDatas));
        } else {
          // Message({message:res.msg,type:"error",duration:1000});
        }
      });
    },
    getTaskHisData: function () {
      promise({
        url: BASIC + "/task/getProcessHisByBusKey",
        method: "get",
        params: {
          businessKey: this.businessKey
        }
      }).then(res => {
        var data = res.data.reverse();
        this.taskHis = data
      });
    },
  },
  created() {
    // this.getTaskHisData();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatTime(date, 'yyyy-MM-dd hh:mm');
    }
  },
}



// WEBPACK FOOTER //
// ./src/view/index/task/index.vue